module.exports = __webpack_public_path__ + "static/media/f5ead409-05f0-4c59-b84f-a2dedc827d3c.059d735a.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/f5ead409-05f0-4c59-b84f-a2dedc827d3c.jpg
// module id = 867
// module chunks = 0